export default "__VITE_ASSET__ee03ff0c__"